import CONSTANTS from "@/store/constants";

const FORM_LABELS = {
    COMPANY_AND_CODE_NAME: 'Company code and name',
    SUPPLIER_ID: 'Supplier ID',
    NAME_OF_SUPPLIER: 'Name of supplier',
    INVOICE_AMOUNT: 'Invoice amount',
    INCL_TAX_VAT_IF_ANY: '(including tax/VAT, if any)',
    CURRENCY: 'Currency',
    INVOICE_DATE: 'Invoice date',
    PAYMENT_DUE_DATE: 'Payment due date',
    SHIP_TO_LOCATION: 'Ship-to location',
    FOR_INDIA_INVOICES_ONLY: '(for India invoices only)',
    INVOICE_REFERENCE_FOR_CREDIT_MEMO: 'Invoice reference for credit memo',
    DESCRIPTION_OF_INVOICE: 'Description of invoice',
    EXPENSE_TYPE: 'Expense type',
    EXPENSE_TYPE_SUBDESC: `If you cannot find an appropriate expense type, please contact <a href=${CONSTANTS.ACCOUNTS_PAYABLE_SLACK} target="_blank"><strong>Accounts Payable via Lumi</strong></a>`,
    SPECIAL_INSTRUCTIONS: 'Special instructions to be stipulated on the payment',
    SPECIAL_INSTRUCTIONS_SUBDESC: '(e.g., payment reference #, tax reference #, etc.)',
    ADD_INVOICE_DETAILS: 'Add line items',
    INVOICE_DETAILS: 'Line items',
    ADD_INVOICE_DETAILS_SUBDESC: '(description, GL account, cost center, WBS, amount)',
    TAX_VAT_AMOUNT: 'Tax/VAT amount',
    OPTIONAL: '(Optional)',
    TOTAL_AMOUNT: 'Total amount',
    TOTAL_AMOUNT_SUBDESC: 'Net amount plus tax/VAT amount',
    UNMATCHED_AMOUNT: 'Unmatched amount',
    UNMATCHED_AMOUNT_SUBDESC: 'Equal to invoice amount (include tax/VAT, if any) minus total amount',
    FOR_TAX_TEAM_ONLY: 'For Tax team only',
    DIRECT_INDIRECT_TAX_RECONCILIATION: '(Direct/indirect tax reconciliation)',
    DOC_HEADER_TEXT: 'Doc Header text',
    ASSIGNMENT: 'Assignment',
    I_HAVE_A_CREDIT_MEMO: 'I have a credit memo, not an invoice.',
    WHAT_IS_A_CREDIT_MEMO: 'What is a credit memo?',
    DESCRIPTION: 'Description',
    GL_ACCOUNT: 'G/L account',
    GL_ACCOUNT_TOOLTIP: 'Please check with your FBPs for G/L account',
    COST_CENTER: 'Cost center',
    COST_CENTER_TOOLTIP: 'Please check with your FBPs for cost center <br /> Cost centers are mandatory if G/L Account begins with a 6 or a 7',
    WBS: 'WBS',
    WBS_WHERE_APPLICABLE: '(Where applicable)',
    WBS_TOOLTIP: 'WBS is Work breakdown structure',
    AMOUNT: 'Amount',
    NET_AMOUNT: 'Net amount',
    ADD_ITEMS: 'Add items',
    UPDATE_ITEMS: 'Update items',
    ADD_AN_INVOICE: '+Add a line item',
    ADD_ANOTHER_INVOICE: '+Add another line item',
    TYPE_OF_PAYMENT_LABEL: 'Please select the type of payment',
    TYPE_OF_PAYMENT_ERROR_LABEL: 'Type of payment',
    ACCOUNT_HOLDER_NAME: 'Account holder name',
    BANK_NAME: 'Bank name',
    BANK_COUNTRY_OF_ORIGIN: 'Bank - country of origin',
    BANK_TYPE_OF_ACCOUNT: 'Type of account',
    BANK_ACCOUNT_NUMBER: 'Bank account number',
    BANK_IBAN: 'IBAN',
    BANK_AND_BRANCH_CODE: 'Bank and branch code',
    BANK_SWIFT_CODE: 'Swift code (BIC)',
    DIRECT_DEBIT_DEDUCTION_DATE: 'Direct debit deduction date',
    PAYROLL_PAYMENT_DATE: 'Payroll payment date',
    PAYMENT_REQUEST_AMOUNT: 'Payment request amount',
    INVOICE_REFERENCE_NUMBER: 'Invoice/Reference number',
    DESCRIPTION_OF_PAYMENT: 'Description of payment',
    PURCHASE_ORDER_NUMBER: 'Purchase order (PO) number',
    ONE_TIME_SUPPLIER_ID: 'One time supplier ID',
    ONE_TIME_SUPPLIER_NAME: 'One time supplier name',
    SUPPLIER_TAX_ID: 'Supplier tax ID',
    SUPPLIER_TAX_ID_SUBDESC: '(India/EMEA/LATAM)',
    HOUSE_NO_STREET_NAME: 'House number/Street name',
    STREET_NAME: 'Street name',
    CONTINUED: '(continued)',
    CITY: 'City',
    STATE: 'State/province',
    ZIP: 'Zip/postal code',
    COUNTRY: 'Country',
    BUSINESS_REASON_FOR_ADV_PAYMENT_REQUEST: 'Business reason for advance payment request',
    CREDIT_MEMO_TOOLTIP: 'Negative amount invoice created by a supplier and sent to you to notify you of a credit for the goods or services provided',
    INVOICE_DATE_TOOLTIP: 'The date that supplier indicates on an invoice which represents a good is sent out or service is going to perform',
    PAYMENT_DUE_DATE_SUBDESC: `The date that payment must reach supplier’s bank account. Do note that Autodesk Standard Payment Term is net 60 days and request to pay earlier than payment term, 
                                you may refer to the information and process 
                                <a class="solution-link" href="https://employeehub.autodesk.com/PTP/articles/0d54285adbf71450234b7914b996198d" target="_blank">here</a> in Employee Hub.`,
    PO_BASED_PAYMENT_DESC: 'Request to pay supplier with special and specified payment instructions for invoices with purchase order number only',
    ADVANCE_PO_PAYMENT_DESC: 'Request to pay supplier for special services which requires advance or deposit payment for event or project without a valid invoice',
    OTV_FORM_DESC: 'Request to pay a supplier with a one-time business transaction only, with invoice amount per One-Time Vendor Policy',
    NON_PO_PAYMENT_DESC: 'Request to pay supplier with non-purchase order spend types per Procurement Policy',
    SUBMIT_AN_INVOICE_DESC: 'Submit an invoice to indicate order numbers on the document',
    PREVIEW_INVOICE_SUBMISSION: `To expedite your payment, please refer to 
                                <a class="solution-link" href="https://employeehub.autodesk.com/PTP/articles/0d54285adbf71450234b7914b996198d" target="_blank"> 
                                payment terms and exception request</a> to understand payment exception process. 
                                <br />Once you have reviewed all the details, scroll down and submit.`,
    VIEW_PURCHASE_ORDERS_DESC: `View your purchase order details and track status`,
    VIEW_INVOICES_DESC: `View your invoices and track status`,
    BOLETO_SLIP_EXPIRY_DATE: 'Boleto slip expiry date',
    PO_18_MONTHS_DESCRIPTION: `Purchase orders are archived after ${CONSTANTS.MONTHS_WORTH_OF_DASHBOARD_DATA} months and are no longer accessible. Please refer to these <a href=${CONSTANTS.ACCOUNTS_PAYABLE_FAQ} target="_blank"><strong>FAQs</strong></a> or contact <a href=${CONSTANTS.ACCOUNTS_PAYABLE_SLACK} target="_blank"><strong>Accounts Payable via Lumi</strong></a> for more information.`,
    INVOICE_18_MONTHS_DESCRIPTION: `Invoices are archived after ${CONSTANTS.MONTHS_WORTH_OF_DASHBOARD_DATA} months and are no longer accessible. Please refer to these <a href=${CONSTANTS.ACCOUNTS_PAYABLE_FAQ} target="_blank"><strong>FAQs</strong></a> or contact <a href=${CONSTANTS.ACCOUNTS_PAYABLE_SLACK} target="_blank"><strong>Accounts Payable via Lumi</strong></a> for more information.`,
    SUCCESS_FOOTER_NOTE: `If you could not find the invoice on the <a href="${CONSTANTS.EH_URL}/apps/supplier-central/invoice-dashboard" target="_blank">invoice dashboard</a> after 10 minutes, please reach out to <a href=${CONSTANTS.ACCOUNTS_PAYABLE_SLACK} target="_blank">Accounts Payable via Lumi.</a>`,
    PAYMENT_DUE_DATE_HELP_TEXT: ' What is a payment due date?',
    INVOICE_DATE_HELP_TEXT: ' What is an invoice date?',
    EXPENSE_TYPE_HELP_TEXT: ' What is an expense type?',
    SUBMIT_AN_INVOICE: 'Submit an invoice',
    VIEW_PURCHASE_ORDERS_INVOICE_MODAL_TITLE: 'View purchase order/invoice status or invoice submission',
    OTV_FORM_TITLE: 'Submit a one-time supplier invoice',
    NON_PO_TITLE: 'Submit a non-purchase order invoice',
    PO_BASED_FORM_TITLE: 'Submit a purchase order without an invoice',
    ADV_PO_BASED_FORM_TITLE: 'Submit an advanced purchase order invoice',
    INVOICE_SUBMISSION_FORM_TITLE: 'Submit an invoice or credit memo',
    SHOW_BANK_ACCOUNT_NUMBER: 'Show bank account number',
    SHOW_IBAN: 'Show IBAN',
    IBAN_FULL_TEXT: 'International Bank Account Number',
    TOOLTIPS: {
        invoiceAmountToolTip: `Includes taxes`,
        dateTooltip: `Format is YYYY-MM-DD`,
        remainingAmountToolTip: `This field displays the remaining purchase order amount only and does not include taxes. It will not match with the invoice amount which includes taxes.`
    },
    INVOICE_WEBFORM_FOOTER:`Have questions or need help? Read our <a href="${CONSTANTS.FOOTER_FAQ_URL}" target="_blank">FAQ</a> or ask <a href="${CONSTANTS.LUMI_SLACK}" target="_blank">Lumi</a>.`,
    ACCOUNTS_PAYABLE_HELP_TEXT: `Please reach out to <a class="solution-link" href="${CONSTANTS.ACCOUNTS_PAYABLE_SLACK}" target="_blank">Accounts Payable via Lumi</a> for assistance regarding any invoice submission.`,
    INVOICE_SUBMISSION_MODAL_ADDITIONAL_TEXT: `For Invoice Submission, each submitted attachment will be tracked as an individual request in the submitted invoices dashboard`,
}

export default FORM_LABELS